<div class="container-fluid g-0 m-0">
  <div class="d-flex g-0 m-0">
    <div class="sidemenu-nav background-color">
      <h6 class="sidemenu-title">
        {{ "DEVICES_MENU_DEVICESETUP&MANAGEMENT" | translate }}
      </h6>
      <div
        class="sidemenu-item-font item"
        (click)="toggleModal(item.ManageDevices)"
        [ngClass]="{ selected: selectedItem === item.ManageDevices }"
      >
        <span>{{ "DEVICES_MENU_MANAGEDEVICES" | translate }}</span>
      </div>
      <div
        class="sidemenu-item-font item"
        (click)="toggleModal(item.DeviceSetup)"
        [ngClass]="{ selected: selectedItem === item.DeviceSetup }"
      >
        <span>{{ "DEVICES_MENU_DEVICESETUP" | translate }}</span>
      </div>
    </div>
    <div class="sidemenu-content">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
